import script from "./VuetableFieldMixin.vue?vue&type=script&lang=js"
export * from "./VuetableFieldMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__